'use client';

import type { SelectionBox as SelectionBoxType } from '../_hooks/use-selection-box';

interface SelectionBoxProps {
  selectionBox: SelectionBoxType;
  isSelecting: boolean;
}

export function SelectionBox({ selectionBox, isSelecting }: SelectionBoxProps) {
  if (!isSelecting || !selectionBox.isActive) {
    return null;
  }

  const { startX, startY, endX, endY } = selectionBox;

  // 计算选择框的位置和尺寸
  const left = Math.min(startX, endX);
  const top = Math.min(startY, endY);
  const width = Math.abs(endX - startX);
  const height = Math.abs(endY - startY);

  return (
    <div
      className="pointer-events-none absolute z-50 border border-system-blue02 bg-system-blue02/10"
      style={{
        left: `${left}px`,
        top: `${top}px`,
        width: `${width}px`,
        height: `${height}px`,
        transform: 'translate3d(0, 0, 0)', // 启用硬件加速
      }}
    />
  );
}
